import { ThemeTypographyObject } from '../../types/theme';

export type PRESSHeadingTypeVariants = 'PRESSheadline3XL'
| 'PRESSheadline2XL'
| 'PRESSheadlineXL'
| 'PRESSheadlineL'
| 'PRESSheadlineM'
| 'PRESSheadlineS'
| 'PRESSheadlineXS'
| 'PRESSheadlineXXS'
| 'PRESSheadlineXXS'
| 'PRESSheadlineXXXS'
| 'PRESSsubheadS';

type PRESSHeadingVariants = {
  [key in PRESSHeadingTypeVariants]: ThemeTypographyObject
};

const pressHeadingVariants: PRESSHeadingVariants = {
  PRESSheadline3XL: {
    color: 'heading',
    fontSize: [7, 8, 9, 12],
    fontWeight: 'boldest',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 7
  },
  PRESSheadline2XL: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginTop: 5,
    marginBottom: 7
  },
  PRESSheadlineXL: {
    color: 'heading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 7
  },
  PRESSheadlineL: {
    color: 'heading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  PRESSheadlineM: {
    color: 'heading',
    fontSize: [5, 6, 6, 7],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  PRESSheadlineS: {
    color: 'heading',
    fontSize: [5, 6, 6, 6],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  PRESSheadlineXS: {
    color: 'heading',
    fontSize: [5, 5, 5, 5],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  PRESSheadlineXXS: {
    color: 'heading',
    fontSize: [2, 3, 3, 4],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  PRESSheadlineXXXS: {
    color: 'heading',
    fontSize: [1, 1, 1, 1],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  PRESSsubheadS: {
    color: 'subheading',
    fontSize: [1, 2, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  }
};

export type AllPressHeadingTypeVariants = PRESSHeadingVariants;

export const pressHeadingKeyVariants = Object.keys(pressHeadingVariants);

export default pressHeadingVariants;
